import React from 'react';
export function BenefitsSection() {
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <span className="inline-block text-cta font-bold tracking-widest text-sm uppercase mb-4" data-id="element-4">
            EL RECORRIDO
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy leading-tight" data-id="element-5">
            Lo que vas a descubrir
          </h2>
        </div>

        <div className="space-y-8 mb-16" data-id="element-6">
          {/* Part I */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-navy/5 relative overflow-hidden" data-id="element-7">
            <div className="absolute top-0 left-0 w-2 h-full bg-navy" data-id="element-8"></div>
            <div className="mb-6" data-id="element-9">
              <span className="inline-block bg-navy text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-10">
                PARTE I
              </span>
              <h3 className="text-2xl font-serif font-bold text-navy" data-id="element-11">
                Entendiendo el proceso
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-12">
              <li className="flex items-start gap-3" data-id="element-13">
                <span className="text-gold font-bold mt-1" data-id="element-14">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-15">
                  Qué es la glicación y por qué es el proceso más relevante que
                  nadie te explicó
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-16">
                <span className="text-gold font-bold mt-1" data-id="element-17">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-18">
                  Qué son los AGEs y por qué se acumulan sin que lo notes
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-19">
                <span className="text-gold font-bold mt-1" data-id="element-20">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-21">
                  El mapa de órganos afectados — y qué dice la ciencia
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-22">
                <span className="text-gold font-bold mt-1" data-id="element-23">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-24">
                  La conexión corazón-glicación que la investigación documenta
                </span>
              </li>
            </ul>
          </div>

          {/* Part II */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-navy/5 relative overflow-hidden" data-id="element-25">
            <div className="absolute top-0 left-0 w-2 h-full bg-navy" data-id="element-26"></div>
            <div className="mb-6" data-id="element-27">
              <span className="inline-block bg-navy text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-28">
                PARTE II
              </span>
              <h3 className="text-2xl font-serif font-bold text-navy" data-id="element-29">
                Lo que acelera todo
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-30">
              <li className="flex items-start gap-3" data-id="element-31">
                <span className="text-gold font-bold mt-1" data-id="element-32">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-33">
                  Los 3 aceleradores: picos de glucosa + estrés crónico +
                  inflamación
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-34">
                <span className="text-gold font-bold mt-1" data-id="element-35">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-36">
                  Por qué el estrés eleva tu azúcar aunque no comas nada dulce
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-37">
                <span className="text-gold font-bold mt-1" data-id="element-38">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-39">
                  El azúcar que no ves: nombres ocultos en las etiquetas
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-40">
                <span className="text-gold font-bold mt-1" data-id="element-41">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-42">
                  Guía práctica para el supermercado
                </span>
              </li>
            </ul>
          </div>

          {/* Part III */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-navy/5 relative overflow-hidden" data-id="element-43">
            <div className="absolute top-0 left-0 w-2 h-full bg-cta" data-id="element-44"></div>
            <div className="mb-6" data-id="element-45">
              <span className="inline-block bg-cta text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-46">
                PARTE III
              </span>
              <h3 className="text-2xl font-serif font-bold text-navy" data-id="element-47">
                Lo que puedes hacer
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-48">
              <li className="flex items-start gap-3" data-id="element-49">
                <span className="text-cta font-bold mt-1" data-id="element-50">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-51">
                  El orden del plato que reduce el pico de glucosa sin cambiar
                  ingredientes
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-52">
                <span className="text-cta font-bold mt-1" data-id="element-53">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-54">
                  5 hábitos respaldados por evidencia científica
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-55">
                <span className="text-cta font-bold mt-1" data-id="element-56">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-57">
                  Plan de 14 días con checklist + mecanismo de rescate
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-58">
                <span className="text-cta font-bold mt-1" data-id="element-59">✓</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-60">
                  3 acciones que puedes aplicar HOY
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center gap-3" data-id="element-61">
          <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto" data-id="element-62">
            <button className="w-full md:w-auto bg-cta hover:bg-cta-hover text-white font-bold text-base md:text-lg py-4 px-8 rounded-lg transition-all duration-300 shadow-[0_4px_14px_0_rgba(200,16,46,0.39)] hover:shadow-[0_6px_20px_rgba(200,16,46,0.23)] hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-63">
              <span data-id="element-64">🔒 DESCARGAR EBOOK + 3 BONOS — $17.95</span>
            </button>
          </a>
          <p className="text-xs md:text-sm text-navy/60 font-sans" data-id="element-65">
            Acceso inmediato · 4 PDFs descargables · Tuyos para siempre · Pago
            seguro
          </p>
        </div>
      </div>
    </section>;
}